module.exports = __webpack_public_path__ + "static/img/album-status-4.5e5d7af8.png";